// pt-PT source of truth for the dashboard area.
export const dashboard = {
  title: 'Painel',
  subtitle: 'Visão geral dos colaboradores e dos contratos',
  viewPeople: 'Ver colaboradores',
  loading: 'A carregar…',
  welcome: {
    morning: 'Bom dia',
    afternoon: 'Boa tarde',
    evening: 'Boa noite',
    named: '{greeting}, {name}',
    pending: '{count} pedidos de registo por tratar.',
    allClear: 'Não há pedidos de registo por tratar.',
    review: 'Rever pedidos',
  },
  kpi: {
    active: 'Total Ativos',
    doctorate: 'Total Doutorados',
    adminServices: 'Total Serviços Administrativos',
    pending: 'Pedidos pendentes',
  },
  charts: {
    last12Months: 'últimos 12 meses',
    started: {
      title: 'Contratos iniciados',
      aria: 'Contratos iniciados por mês nos últimos 12 meses',
    },
    ended: {
      title: 'Contratos terminados',
      aria: 'Contratos terminados por mês nos últimos 12 meses',
    },
    yearCompare: {
      title: 'Ano anterior vs atual',
      subtitle: 'contratos iniciados',
      aria: 'Comparação de contratos iniciados: ano anterior vs ano atual com previsão',
    },
  },
  legend: {
    previousYear: 'Ano anterior',
    currentYear: 'Ano atual',
    forecast: 'Previsão',
  },
  custom: {
    heading: 'Indicadores personalizados',
    pubsByYear: 'Publicações por ano',
    pubsByMonth: 'Publicações por mês (ano atual)',
    distribution: 'Distribuição de colaboradores por campo',
    citationsByYear: 'Citações por ano',
    quartileDist: 'Distribuição de publicações por quartil',
    pubsByTeam: 'Publicações por equipa',
    topResearchers: 'Top investigadores por publicações',
    yearCompareAria: 'Contratos iniciados: ano anterior vs ano atual com previsão',
    pubsYearCompareAria: 'Publicações: ano anterior vs ano atual com previsão',
    contractsByMonth: 'Contratos por mês nos últimos 12 meses',
  },
  pending: {
    title: 'Pedidos pendentes',
    empty: 'Sem pedidos pendentes. 🎉',
  },
  customize: {
    edit: 'Personalizar',
    done: 'Concluir',
    reset: 'Repor predefinição',
    addTitle: 'Adicionar ao painel',
    allAdded: 'Todos os cartões já estão no painel.',
    dragHint: 'Arraste para reordenar',
    empty: 'O seu painel está vazio. Use "Personalizar" para adicionar cartões.',
    size: {
      sm: 'Pequeno',
      md: 'Médio',
      lg: 'Grande',
    },
  },
  table: {
    name: 'Nome',
    email: 'Email',
    department: 'Departamento',
    received: 'Recebido',
    status: 'Estado',
  },
};
